import { SHOW_AUTH_MODAL } from '@reduxLocal/actions/types';
import { store } from '@reduxLocal/persistState';
import { serializeForReduxDetails } from '@utils/serializeForRedux';

type ErrorModalType = 'error' | 'warning' | 'success' | 'progress';

export interface InterceptAppErrorOptions {
  source?: string;
  message?: string;
  modalType?: ErrorModalType;
  details?: unknown;
}

const resolveErrorMessage = (error: unknown, fallback = 'Something went wrong. Please try again.') => {
  if (typeof error === 'string' && error.trim()) return error;

  const candidate = error as any;
  const message =
    candidate?.response?.data?.message ||
    candidate?.response?.data?.error ||
    candidate?.message ||
    candidate?.error ||
    fallback;

  return typeof message === 'string' && message.trim() ? message : fallback;
};

const buildErrorDetails = (error: unknown, source?: string, details?: unknown) => {
  const candidate = error as any;

  return {
    source: source || 'unknown',
    name: candidate?.name,
    message: candidate?.message,
    code: candidate?.code,
    status: candidate?.response?.status,
    method: candidate?.config?.method,
    url: candidate?.config?.url,
    responseData: candidate?.response?.data,
    stack: candidate?.stack,
    componentStack: candidate?.componentStack,
    details,
  };
};

export const interceptAppError = (error: unknown, options: InterceptAppErrorOptions = {}) => {
  const content = options.message || resolveErrorMessage(error);
  const modalType = options.modalType || 'error';
  const detailPayload = buildErrorDetails(error, options.source, options.details);

  store.dispatch({
    type: SHOW_AUTH_MODAL,
    data: {
      content,
      type: modalType,
      details: serializeForReduxDetails(detailPayload),
    },
  });
};

